<template>
  <div class="privacy-policy-container">
    <div class="privacy-policy-content">
      <h1>{{ title }}</h1>
      <p class="last-update">
        <strong>{{ lastUpdate }}:</strong> {{ updateDate }}
      </p>

      <div class="section">
        <h2>{{ introduction }}</h2>
        <p v-html="introductionContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataCollected }}</h2>
        <p v-html="dataCollectedContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataPurpose }}</h2>
        <p v-html="dataPurposeContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataSharing }}</h2>
        <p v-html="dataSharingContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataRetention }}</h2>
        <p v-html="dataRetentionContent"></p>
      </div>

      <div class="section">
        <h2>{{ security }}</h2>
        <p v-html="securityContent"></p>
      </div>

      <div class="section">
        <h2>{{ policyChanges }}</h2>
        <p v-html="policyChangesContent"></p>
      </div>

      <div class="section">
        <h2>{{ contact }}</h2>
        <p v-html="contactContent"></p>
      </div>

      <div class="section consent-section">
        <h2>{{ consent }}</h2>
        <p v-html="consentContent"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Privacy Policy of the Game Renegado",
      lastUpdate: "Last update",
      updateDate: "11/14/2024",

      introduction: "Introduction",
      introductionContent: `
        Welcome to the game Renegado, developed by Black Paladins. This Privacy Policy describes how we collect, use, and protect your information.
      `,

      dataCollected: "Data Collected",
      dataCollectedContent: `
        The game Renegado does not require login, registration, or active collection of personal data from players. However, we use the Unity Ads platform to display ads, which may collect anonymous data for the purpose of displaying relevant ads.<br><br>
        These data may include:<br>
        - <strong>Device ID:</strong> used by Unity to personalize ads.<br>
        - <strong>Usage information:</strong> such as the number of ad views and interactions for ad performance analysis.<br><br>
        These data are managed by Unity, according to the <a href="https://unity.com/legal/privacy-policy" target="_blank" class="link">Unity Privacy Policy</a>.
      `,

      dataPurpose: "Purpose of Data",
      dataPurposeContent: `
        The collected data are used exclusively to enhance the ad experience within the game, providing relevant and personalized advertising through Unity Ads. We do not collect, store, or share any personally sensitive information directly.
      `,

      dataSharing: "Data Sharing",
      dataSharingContent: `
        The data collected by Unity Ads may be shared with third parties for advertising and analytics purposes.<br>
        For more information on how Unity handles the data, refer to the <a href="https://unity.com/legal/privacy-policy" target="_blank" class="link">Unity Privacy Policy</a>.
      `,

      dataRetention: "Data Retention and Deletion",
      dataRetentionContent: `
        As a developer, Black Paladins does not collect or retain personal data from players. Unity Ads manages its own data according to its retention and deletion practices, available in the Unity Privacy Policy.
      `,

      security: "Security",
      securityContent: `
        We value the privacy and security of our players. Unity Ads adopts appropriate security measures to protect the processed data, but we remind you that no data transmission over the internet is 100% secure.
      `,

      policyChanges: "Changes to This Privacy Policy",
      policyChangesContent: `
        This privacy policy may be periodically updated. The last updated date will be indicated at the beginning of this document. We recommend that you review this policy regularly.
      `,

      contact: "Contact",
      contactContent: `
        If you have any questions about this Privacy Policy or the game Renegado, please contact us:<br>
        Black Paladins - Support Team<br>
        Email: blackpaladinsgames@gmail.com
      `,

      consent: "Consent",
      consentContent: `
        By using the game Renegado, you agree to this Privacy Policy.
      `
    };
  }
};
</script>


<style scoped>
.privacy-policy-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #1e1e2f;
  color: #e0e0e0;
  font-family: Arial, sans-serif;
  padding: 80px;
}

.privacy-policy-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  border-radius: 12px;
  background: rgba(34, 34, 51, 0.85);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-in-out;
}

.last-update {
  font-size: 1.1em;
  text-align: center;
  color: #cfcfcf;
  margin-bottom: 30px;
}

.section {
  margin-bottom: 25px;
}

p {
  font-size: 1.1em;
  line-height: 1.8;
  color: #e0e0e0;
  margin-bottom: 15px;
}

.consent-section p {
  font-style: italic;
  color: #ffd700;
}

strong {
  font-weight: bold;
}

.link {
  color: #ffcc00;
  text-decoration: underline;
}

.link:hover {
  text-decoration: none;
  color: #ffd700;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
